import React, {useState} from 'react';
import * as Icon from 'react-feather';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../hooks/redux';

import {
    Button as AlchemyButton,
    Tooltip as AlchemyTooltip,
} from '@amzn/alchemy-components-react';

import { removeFavourite as removeMyFavouriteItem } from '../../slices/myFavouritesSlice';
import { removeFavourite as removeSiteFavouriteItem } from '../../slices/siteFavouritesSlice';
import { addMessage } from '../../slices/messageQueueSlice';
import { FavouritesApiService } from '../../api';
import {itemTypes} from '../../enums/ItemTypes.enum';
import i18n from "../../i18n";
import { RootState } from '../../types';

interface RemoveFavoriteButtonProps {
    favoritesType: number;
    bookmark: any;
    size?: "sm" | "md" | "lg";
    iconSize?: string;
}

export default function(props: RemoveFavoriteButtonProps) {
    const favoritesType:number = props.favoritesType
    const bookmark = props.bookmark
    const size = props.size || "sm"
    const iconSize = props.iconSize || "16"
    const currentUser = useSelector((state: RootState) => state.user);
    // TODO
    let entity = ''
    let msg = ''
    let tip = ''
    let tooltipLabel = ''
    let dataTableUpdateFunction:any
    switch (favoritesType) {
        case itemTypes.myFavourites:
            entity = currentUser.login
            msg = i18n.t('toast:removed-for-you')
            tooltipLabel = `${i18n.t('button:remove-bookmark-for')} ${currentUser.login}`
            dataTableUpdateFunction = removeMyFavouriteItem
            break
        case itemTypes.siteFavourites:
            entity = currentUser.whid
            msg = `${i18n.t('toast:removed-for')} ${currentUser.whid}`
            tooltipLabel = `${i18n.t('button:remove-bookmark-for')}  ${currentUser.whid}`
            dataTableUpdateFunction = removeSiteFavouriteItem
            break
    }

    const dispatch = useAppDispatch();
    const favApi = new FavouritesApiService();

    const handleRemoveFavourite = () => {

        async function removeFav() {
            const response: any = await favApi.removeCurrentEntityFav(entity, String(favoritesType), [bookmark.entity])
            console.log('Remove favorite API response:', response);
            
            // Enhanced debugging to understand the API response structure
            console.log('API Response Type:', typeof response);
            console.log('API Response Keys:', response ? Object.keys(response) : 'No keys (response is null/undefined)');
            
            if (response && typeof response === 'object') {
                console.log('Has Attributes?', 'Attributes' in response);
                if ('Attributes' in response) {
                    console.log('Attributes Type:', typeof response.Attributes);
                    console.log('Attributes Keys:', Object.keys(response.Attributes));
                    console.log('Attributes.favorites:', response.Attributes.favorites);
                    console.log('Attributes.favorites Type:', typeof response.Attributes.favorites);
                    if (Array.isArray(response.Attributes.favorites)) {
                        console.log('favorites Array Length:', response.Attributes.favorites.length);
                        console.log('favorites First Item:', response.Attributes.favorites[0]);
                    }
                }
            }
            
            // Handle the response more defensively
            let favorites: string[] = [];
            
            // First check if response and Attributes exist
            if (response && response.Attributes) {
                // Check if favorites exists in Attributes
                if (response.Attributes.favorites !== undefined) {
                    favorites = Array.isArray(response.Attributes.favorites) 
                        ? response.Attributes.favorites.map((item: any) => String(item))
                        : [String(response.Attributes.favorites)];
                } else {
                    console.warn('No favorites found in response Attributes');
                    // Use entity ID to remove from local state
                    favorites = [bookmark.entity]; 
                }
            } else {
                console.warn('Unexpected API response structure:', response);
                // Use entity ID to remove from local state
                favorites = [bookmark.entity];
            }
            // Dispatch to the respective slice to update the DataTable view
            dispatch(dataTableUpdateFunction([bookmark.entity]))
            dispatch(addMessage({
                id: Date.now().toString(),
                icon: "remove",
                title: msg,
                text: bookmark.title || bookmark.description,
                duration: 5000
            }))
            // TODO: BETA
            // dispatch(addToast(
            //     Date.now().toString(),
            //     "info",
            //     "May I have your attention, please?",
            //     "This is currently a BETA test and bookmarks you create will not persist. Please do not use for production.",
            //     "",
            //     8000
            // ))
        }
        removeFav();
    }

    return (
        <AlchemyTooltip position="top">
            <span slot="trigger">
                <AlchemyButton
                    size={size}
                    disabled={bookmark.isExample}
                    onClick={handleRemoveFavourite}>
                    <Icon.Slash size={iconSize} />
                </AlchemyButton>
            </span>
            <p className='mb-0'>{bookmark.isExample ? i18n.t('button:prevent-del-example-bookmark') : tooltipLabel}</p>
        </AlchemyTooltip>
    );
}
